import { HeaderCategories } from '@/behaviour/header_navigation/category'
import { HeaderFixedNavigation } from '@/behaviour/header_navigation/scroll'
import { classes } from '@/behaviour/header_navigation/variables'
import { $ } from '@/libs/jquery/index'

export class HeaderNavigation {
  // установка пункта меню активным
  public static setMenuLinkActive(selector: string): void {
    $(selector).addClass(classes.active)
  }

  private selectors: ISelectors = {
    base: '[data-selector="header"]',
  }

  private base: JQuery | null = null

  public constructor() {
    this.base = $(this.selectors.base)
    if (this.base.length) {
      this.init()
    }
  }

  private init(): void {
    const categories = new HeaderCategories()
    const fixedMenu = new HeaderFixedNavigation()
  }

}
